import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation } from '../../../../Api/ApiMethods';

const CityDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedCity, refreshData }) => {
    const initialCityData = {
        id: '',
        title: '',
        order: '',
        district: [''],
    };

    const [cityData, setCityData] = useState(initialCityData);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isOpen) {
            if (mode === 'modify' && selectedCity) {
                setCityData({ ...initialCityData, ...selectedCity });
            } else {
                resetForm();
            }
        }
    }, [mode, selectedCity, isOpen]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let processedValue = value;

        const fieldsToUppercase = ['title'];

        if (fieldsToUppercase.includes(name) && typeof value === 'string') {
            processedValue = value.toLocaleUpperCase('tr-TR');
        }

        setCityData({ ...cityData, [name]: processedValue });

        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    const validateForm = () => {
        const validationErrors = {};
        const orderRegex = /^-?[0-9]+$/;
        const titleRegex = /^[A-ZĞÜŞİÖÇa-zğüşıöç ]{3,50}$/i;

        if (!cityData.title.trim()) {
            validationErrors.title = 'Şehir adı zorunludur.';
        } else if (!titleRegex.test(cityData.title)) {
            validationErrors.title = 'Şehir adı sadece harf ve boşluk içerebilir minimum 3 karakter maksimum 50 karakter desteklemektedir.';
        }

        if (!cityData.order) {
            validationErrors.order = 'Sıra numarası zorunludur.';
        } else if (!orderRegex.test(cityData.order)) {
            validationErrors.order = 'Sıra numarası sadece rakam içermelidir.';
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const resetForm = () => {
        setCityData(initialCityData);
        setErrors({});
    };

    const handleCancel = () => {
        resetForm();
        toggle();
    };

    const handleOperation = async () => {
        if (!validateForm()) {
            toast.error("Lütfen formdaki hataları düzeltin.");
            return;
        }

        const payload = {
            order: Number(cityData.order),
            title: cityData.title
        };

        await handleAddModifyOperation({
            apiEndpoint,
            selectedItem: mode === 'modify' ? selectedCity : null,
            mode,
            data: payload,
            refreshDataCallback: refreshData,
            componentName: 'Şehir',
        });

        handleCancel();
    };

    const getModalTitle = () => {
        return mode === 'add' ? 'Şehir Ekle' : 'Şehir Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel}>
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="order">Sıra <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="order"
                            name="order"
                            value={cityData.order}
                            onChange={handleInputChange}
                            invalid={!!errors.order}
                        />
                        {errors.order && <div className="text-danger small mt-1">{errors.order}</div>}
                    </FormGroup>
                    <FormGroup>
                        <Label for="title">Şehir Adı <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={cityData.title}
                            onChange={handleInputChange}
                            invalid={!!errors.title}
                        />
                        {errors.title && <div className="text-danger small mt-1">{errors.title}</div>}
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-primary" onClick={handleOperation}>
                    {getButtonLabel()}
                </button>
                <button className="btn btn-secondary" onClick={handleCancel}>
                    İptal
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default CityDataModal;
